import * as React from "react";
import FeaturedEvent from "./FeaturedEvent";
import UpcomingEvents from "./UpcomingEvents";
import ContactForm from "@components/ContactForm";
import * as styles from "./Events.module.scss";
import SignUpForm from '@components/ContactForm/SignUpForm';

const featuredEvent = {
  title: "Beers & Business",
  venue: "http://www.brownmountainbottleworks.com",
  eventLocation: "115 E Union St Morganton, North Carolina",
  eventDate: "August 10th, 2021.  6:00 pm - 8:00 pm",
  description:
    "Business enthusiasts coming together to celebrate and vent about the joy and struggles of producing value in and around our local communities."
};

const upcomingEventsArray = [

  "September 14th, 2021.  6:00 pm - 8:00 pm",
  "October 12th, 2021, 6:00 pm - 8:00 pm",
  "November 9th, 2021, 6:00 pm - 8:00 pm "
];


const previousEventsArray = [
  {
    title: "Beers & Business : July Edition",
    date: "July 13th, 2021",
    time: "6:00 pm - 8:00 pm",
    location: "Morganton, NC"
  },
  {
    title: "Beers & Business : June Edition",
    date: "June 8th, 2021",
    time: "6:00 pm - 8:00 pm",
    location: "Morganton, NC"
  },
  {
    title: "Lorem ipsum dolor sit amet.",
    date: "Lorem, XXX",
    time: "xx:xx pm - xx:xx pm",
    location: "Morganton, NC"
  }
];

const PreviousEvents = ({events}) => (
  <div className={styles.previous_events}>
    
    <div className={styles.previous_events_column}>
      <span className={styles.column_title}>Event</span>
       <span>{events[0].title}</span>
      <span>{events[1].title}</span>
      {/* <span>{events[2].title}</span> */}
    </div>

    <div className={styles.previous_events_column}>
      <span className={styles.column_title}>Date</span>
      <span>{events[0].date}</span>
      <span>{events[1].date}</span>
      {/* <span>{events[2].date}</span> */}
    </div>
    
    <div className={styles.previous_events_column}>
      <span className={styles.column_title}>Time</span>
      <span>{events[0].time}</span>
      <span>{events[1].time}</span>
      {/* <span>{events[2].time}</span> */}
    </div>
    <div className={styles.previous_events_column}>
      <span className={styles.column_title}>Location</span>
      <span>{events[0].location}</span>
      <span>{events[1].location}</span>
     {/*  <span>{events[2].location}</span> */}
    </div>
  </div>
);

const EventsComponent = () => {
  return (
    <div className={`${styles.events} container`}>
      <section className={styles.header}>
        <h1>Events</h1>
      </section>

      <article className={styles.featured_event}>
        {<FeaturedEvent {...featuredEvent} />}
      </article>

      <article className={styles.upcoming_events}>
        
        <UpcomingEvents events={upcomingEventsArray} />
      </article>

      <article style={{overflowX: "auto"}}>
        <PreviousEvents events={previousEventsArray.slice(0,3)} />
      </article>

      <section>
        <SignUpForm />
      </section>
      
      {/* <section>
        <ContactForm />
      </section> */}
    </div>
  );
};

export default EventsComponent;
